import * as React from 'react'
import { Modal } from '@doordash/component-modal'
import Button from '@doordash/component-button'
import { Text } from '@doordash/design-language'
import i18n from '../../../../../i18n'
import { i18nKeys } from 'translationTypes'
import * as DA from '../../../../../typeModules/events'

const SEND_SMS_COOLDOWN = 3000 // in MS

const handleSend = (onSend, setIsResendOnCooldown) => {
  setIsResendOnCooldown(true)
  onSend()
  setTimeout(() => setIsResendOnCooldown(false), SEND_SMS_COOLDOWN)
}

export const SmsSentConfirmation = ({
  onClose,
  onBack,
  onClick,
  isSending,
  trackReturnToApplication
}) => {
  const [isResendOnCooldown, setIsResendOnCooldown] = React.useState(false)
  React.useEffect(() => {
    trackReturnToApplication(
      DA.EventActions.Rendered,
      DA.ReturnToApplication.ReclaimSMSConfirm
    )
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  // TODO(markn): remove above disable after updating lint rule
  return (
    <Modal
      title={i18n.t(i18nKeys.startedSigningUp_sms_sent_title)}
      onClose={onClose}
      isFullScreenOnMobile={false}
      primaryAction={{
        text: i18n.t(i18nKeys.startedSigningUp_sms_prompt_button_text_resend),
        onClick: () => handleSend(onClick, setIsResendOnCooldown),
        buttonProps: {
          state: isSending ? Button.States.Loading : Button.States.Default,
          isDisabled: isResendOnCooldown,
        }
      }}
      secondaryAction={{
        text: i18n.t(i18nKeys.common__back),
        onClick: onBack,
      }}
    >
      <Text>{i18n.t(i18nKeys.startedSigningUp_sms_sent_description)}</Text>
    </Modal>
  )
}
